import { getPressclipping } from '@/graphql/queries/media/pressclipping';
import lang from '@/lang/middleware/media';

export default async ({ $apolloQuery, app, redirect, route, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  await $apolloQuery(getPressclipping, { slug: route.params.slug }).then(clipping => {
    store.commit('blog/setPressclipping', clipping);
    store.commit('pageContent/setHead', { description: clipping.text, title: clipping.title });
  }).catch(e => {
    console.error(e);
//    redirect(301, app.localePath('/in-the-media/'));
  });
};
